import cn from 'client/utils/cn';

import React, { Component } from 'react';

import Breadcrumbs from 'client/components/breadcrumbs';
import Chart from 'client/components/chart';
import SectionShiftTitle from 'client/components/section-shift-title';
import WideStripe from 'client/components/wide-stripe';
import LangContext from 'client/utils/lang-context';

import { AboutGrowthImage, ChartData, PageAboutGrowthProps } from 'client/bundles/types';

import './index.css';

const b = cn('about-growth');
const bPageTitle = cn('page-title');
const bPageText = cn('page-text');

interface Props {
    growthData?: PageAboutGrowthProps;
}

export default class AboutGrowth extends Component<Props> {
    static contextType = LangContext;

    renderDescription = (text: string) => {
        return (
            <p className={b('card-description')}>
                {text}
            </p>
        );
    }

    renderChart = (chart: ChartData, image: AboutGrowthImage) => {
        return (
            <div className={b('card-chart')}>
                <Chart
                    title={chart.title}
                    image={image['growth-phone']}
                    imageTablet={image['growth-desktop']}
                    />
            </div>
        );
    }

    render() {
        const { growthData } = this.props;

        if (!growthData) {
            return;
        }

        const { title, text, card, image } = growthData;
        const { dictionary } = this.context;

        return (
            <div className={b()}>
                <Breadcrumbs link="/about" text={dictionary.about} />

                <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>

                <div className={bPageText()} dangerouslySetInnerHTML={{ __html: text }} />

                <div className={b('content')}>
                    <WideStripe>
                        <SectionShiftTitle
                            ratios="28-66"
                            title={card.title}
                            childrenFirst={this.renderDescription(card.text)}
                            childrenSecond={this.renderChart(card.chart, image)}
                            />
                    </WideStripe>
                </div>
            </div>
        );
    }
}
